import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import "./paginationhoc.scss"



const MultiListPage = ({ list, renderItem,count,screensize}) => {
    let timeIntervel = null
    const containerRef = useRef(null);
    const [pageLoading, setpageLoading] = useState(false)
    const [currentindex, setcurrentindex] = useState(0)
    const [totalindex, settotalindex] = useState(list?.length)
    const [width, setwidth] = useState(window?.innerWidth)
    const [listData, setlistData] = useState([])
    useEffect(()=>{
        return () => {
            clearInterval(timeIntervel)
        }
    },[])
    useEffect(() => {
        getWidth()
        const container = containerRef.current;
        if (container) {
            // container.addEventListener('scroll',handleScroll );
          container.addEventListener('scrollend', handleScroll);
        }
        window.addEventListener('resize', () => {
            // setwidth(window?.innerWidth)
            getWidth()
        });
        return () => {
            clearInterval(timeIntervel)
            if (container) {
                // container.removeEventListener('scroll', handleScroll);
                container.removeEventListener('scrollend', handleScroll);
            }
        }
        
    }, [list])
    const getWidth = () => {
        let width = window?.innerWidth
        setwidth(width)
        if(width > 1100) {
            let data = [...list] || []
            let newData = []
            while (data.length > 0) {
                newData.push(data.splice(0, 4))
            }   
            setlistData(newData)
            settotalindex(newData?.length)
        } else if(width > 600) {
            let data = [...list] || []
            let newData = []
            while (data.length > 0) {
                newData.push(data.splice(0, 2))
            }   
            setlistData(newData)
            settotalindex(newData?.length)

        } else {
            setlistData(list)
            settotalindex(list?.length)
        }
        setcurrentindex(0)
    }
    useEffect(() => {
        timeIntervel = setInterval(() => {
            const container = containerRef.current;
        if (container) {
            let ci = (Math.round(container.scrollLeft / container.offsetWidth));
            ci=(ci+1) % totalindex
            if (totalindex > 0) {
                setcurrentindex(ci)
     } 
        }
        }, 10000);
        return()=>{
            clearInterval(timeIntervel)
        }
    }, [totalindex])
    useEffect(() => {

        clearInterval(timeIntervel)
        const container = containerRef.current;
        if (container) {
         container.scrollLeft = (currentindex) * (container.offsetWidth );
        }
      }, [currentindex]);
    
      const handleScroll = (event) => {
        clearInterval(timeIntervel)
        const container = containerRef.current;
        setcurrentindex(Math.round((container.scrollLeft) / (container.offsetWidth )))
    };

    return (
        <div className={"multirowlist"}  >
            {!pageLoading && <div    className="pagpeView" ref={containerRef}>
                    {listData.map((item,index)=>(
                        <div  className={"carousel-card"}>
                             {(
                                (item?.length > 0) ? <Row xs={2} sm={2} md={2} lg={2} className={"carousel-card"} >
                                    {listData?.[index]?.length >0 && item?.map((item, index) => {
                                        return (
                                            <Col className='carousel-column'>
                                                {renderItem(item, index)}
                                            </Col>
                                        )
                                    })}
                                </Row> :
                                <div className='carousel-column'>
                                     { renderItem(listData[index], index)
                                    }
                                    </div>
                               
                            )}
                        </div>
                      
                    ))}  
                    {/* {[...Array(totalindex)].map((item,index)=>(
                        <div>
                            {listData?.length > index ? (
                                (listData?.[index]?.length > 0) ? <Row xs={2} sm={2} md={2} lg={2} className={"carousel-card"} >
                                    {listData?.[index]?.length >0 && listData?.[index]?.map((item, index) => {
                                        return (
                                            <Col className='w-50'>
                                                {renderItem(item, index)}
                                            </Col>
                                        )
                                    })}
                                </Row> :
                                <div  className={"carousel-card"}  >{
                                 renderItem(listData[index], index)
                                } </div>
                            )
                                : null}
                        </div>
                    ))} */}
            </div>}
            <div className='page-box'>
            {
                    totalindex > 1 && [...Array(totalindex)].map((item, index) => (
                    <div role={"button"} onClick={()=>{
                       setcurrentindex(index)
                     }} className={`dot ${index == currentindex ? "active-dot neon ":""}`}>{}</div>
                ))
            }
            </div>

        </div>
    );
};

export default MultiListPage;

